module.exports = __webpack_public_path__ + "img/mono-square.6fa590f1.svg";